import { GENDERED_LOCALES } from '../consts/gendered-locales';
export const isGenderedLocale = (locale) => !!locale && GENDERED_LOCALES.has(locale);
